var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAltSolid = function SvgUserAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5c-3.855 0-7 3.145-7 7 0 2.41 1.23 4.55 3.094 5.813C8.527 19.343 6 22.883 6 27h2a7.98 7.98 0 0 1 3.813-6.812A4.54 4.54 0 0 0 16 23a4.54 4.54 0 0 0 4.188-2.812A7.98 7.98 0 0 1 24 27h2c0-4.117-2.527-7.656-6.094-9.187A7.02 7.02 0 0 0 23 12c0-3.855-3.145-7-7-7m0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5-5-2.227-5-5 2.227-5 5-5m0 12q1.23.002 2.344.344a2.485 2.485 0 0 1-4.688 0A8 8 0 0 1 16 19"
  })));
};
export default SvgUserAltSolid;